/**
 * Created by andrey on 04.05.17.
 */

cleverapps.Environment = function () {
    cleverapps.EventEmitter.call(this);

    this.episodeNo = levels.user.currentPhysicalLevel.episode;
    this.levelNo = levels.user.currentPhysicalLevel.level;
    this.locationId = undefined;

    this.scene = undefined;
};

cleverapps.Environment.prototype = Object.create(cleverapps.EventEmitter.prototype);
cleverapps.Environment.prototype.constructor = cleverapps.Environment;

cleverapps.Environment.prototype.setScene = function (name) {
    this.scene = name;
    this.trigger("changeScene", name);
};

cleverapps.Environment.prototype.setLevel = function (levelNo) {
    this.levelNo = levelNo;
    this.trigger("update");
};

cleverapps.Environment.prototype.setEpisode = function (episodeNo) {
    this.episodeNo = episodeNo;
    this.trigger("update");
};

cleverapps.Environment.prototype.setLocationId = function (locationId) {
    this.locationId = locationId;
    this.trigger("update");
};

cleverapps.Environment.prototype.isDailyCupScene = function () {
    return this.scene === cleverapps.Environment.SCENE_DAILY_CUP;
};

cleverapps.Environment.prototype.isMainScene = function () {
    return this.scene === cleverapps.Environment.SCENE_MAIN;
};

cleverapps.Environment.prototype.isLoaderScene = function () {
    return this.scene === cleverapps.Environment.SCENE_LOADER;
};

cleverapps.Environment.prototype.isHeroesScene = function () {
    return this.scene === cleverapps.Environment.SCENE_HEROES;
};

cleverapps.Environment.prototype.isGameScene = function () {
    return this.scene === cleverapps.Environment.SCENE_GAME;
};

cleverapps.Environment.prototype.isEditorScene = function () {
    return this.scene === cleverapps.Environment.SCENE_EDITOR;
};

cleverapps.Environment.prototype.isChatScene = function () {
    return this.scene === cleverapps.Environment.SCENE_CHAT;
};

cleverapps.Environment.prototype.isMineScene = function () {
    return this.scene === cleverapps.Environment.SCENE_MINE;
};

cleverapps.Environment.prototype.isAdministratorScene = function () {
    return this.scene === cleverapps.Environment.SCENE_ADMINISTRATOR;
};

cleverapps.Environment.prototype.isSceneWithPreview = function () {
    return this.scene === cleverapps.Environment.SCENE_EDITOR || this.scene === cleverapps.Environment.SCENE_ADMINISTRATOR;
};

cleverapps.Environment.prototype.isAtlasAnalyzerScene = function () {
    return this.scene === cleverapps.Environment.SCENE_ATLAS_ANALYZER;
};

cleverapps.Environment.prototype.isBonusWorldScene = function () {
    return this.scene === cleverapps.Environment.SCENE_BONUS_WORLD;
};

cleverapps.Environment.prototype.isSlotMachineScene = function () {
    return this.scene === cleverapps.Environment.SCENE_SLOT_MACHINE;
};

cleverapps.Environment.prototype.isComicsScene = function () {
    return this.scene === cleverapps.Environment.SCENE_COMICS;
};

cleverapps.Environment.prototype.isPinballScene = function () {
    return this.scene === cleverapps.Environment.SCENE_PINBALL;
};

cleverapps.Environment.prototype.isOctopusHuntScene = function () {
    return this.scene === cleverapps.Environment.SCENE_OCTOPUS_HUNT;
};

cleverapps.Environment.prototype.onOpenWindow = function () {
};

cleverapps.Environment.prototype.onCloseWindow = function () {
};

cleverapps.Environment.prototype.getActiveWindow = function () {
    const currentWindow = cleverapps.focusManager && cleverapps.focusManager.currentWindow();
    if (currentWindow && currentWindow.name) {
        return currentWindow.name;
    }
};

cleverapps.Environment.prototype.getScreen = function () {
    return this.getActiveWindow() || this.getScene();
};

cleverapps.Environment.prototype.getScene = function () {
    return this.scene;
};

cleverapps.Environment.prototype.hasScene = function (scenes) {
    return scenes.indexOf(this.scene) !== -1;
};

cleverapps.Environment.prototype.hasEpisode = function (episodes) {
    return cleverapps.toArray(episodes).indexOf(String(this.episodeNo)) !== -1;
};

cleverapps.Environment.SCENE_LOADER = "loaderScene";
cleverapps.Environment.SCENE_MAIN = "main";
cleverapps.Environment.SCENE_GAME = "game";
cleverapps.Environment.SCENE_EDITOR = "editor";
cleverapps.Environment.SCENE_ADMINISTRATOR = "administrator";
cleverapps.Environment.SCENE_COMICS = "comics";
cleverapps.Environment.SCENE_HEROES = "heroes";
cleverapps.Environment.SCENE_DAILY_CUP = "dailycup";
cleverapps.Environment.SCENE_TRIPEAKS = "tripeaks";
cleverapps.Environment.SCENE_CHAT = "chat";
cleverapps.Environment.SCENE_BONUS_WORLD = "bonusworld";
cleverapps.Environment.SCENE_SLOT_MACHINE = "slotmachine";
cleverapps.Environment.SCENE_MINE = "mine";
cleverapps.Environment.SCENE_ATLAS_ANALYZER = "atlasanalyzer";
cleverapps.Environment.SCENE_PINBALL = "pinball";
cleverapps.Environment.SCENE_OCTOPUS_HUNT = "octopusHunt";
cleverapps.Environment.SCENE_WEEKLY_TOURNAMENT = "weeklyTournament";
